import * as types from './shipmentStatusActionTypes';

export const getShipmentStatusRequestAction = (payload) => ({
  type: types.GET_SHIPMENT_STATUS_REQUEST,
  payload,
});

export const getShipmentStatusDataAction = (payload) => ({
  type: types.GET_SHIPMENT_STATUS_DATA,
  payload,
});

export const getShipmentStatusErrorAction = (payload) => ({
  type: types.GET_SHIPMENT_STATUS_ERROR,
  payload,
});

export const sortShipmentStatusSortData = (payload) => ({
  type: types.SET_SHIPMENT_SORT_DATA,
  payload,
});

export const sortingShipmentStatusDataAction = (payload) => ({
  type: types.SORTING_SHIPMENT_ACTION,
  payload,
});

export const createShipmentStatusRequestAction = (payload) => ({
  type: types.CREATE_SHIPMENT_STATUS_REQUEST,
  payload,
});

export const createShipmentStatusDataAction = (payload) => ({
  type: types.CREATE_SHIPMENT_STATUS_DATA,
  payload,
});

export const createShipmentStatusErrorAction = (payload) => ({
  type: types.CREATE_SHIPMENT_STATUS_ERROR,
  payload,
});

export const updateShipmentStatusRequestAction = (payload) => ({
  type: types.UPDATE_SHIPMENT_STATUS_REQUEST,
  payload,
});

export const updateShipmentStatusDataAction = (payload) => ({
  type: types.UPDATE_SHIPMENT_STATUS_DATA,
  payload,
});

export const updateShipmentStatusErrorAction = (payload) => ({
  type: types.UPDATE_SHIPMENT_STATUS_ERROR,
  payload,
});

export const deleteShipmentStatusRequestAction = (payload) => ({
  type: types.DELETE_SHIPMENT_STATUS_REQUEST,
  payload,
});

export const deleteShipmentStatusDataAction = (payload) => ({
  type: types.DELETE_SHIPMENT_STATUS_DATA,
  payload,
});

export const deleteShipmentStatusErrorAction = (payload) => ({
  type: types.DELETE_SHIPMENT_STATUS_ERROR,
  payload,
});
